import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { useGridFilterStore } from 'src/store/useGridFilters/useGridFilterStore';
import { ROUTE_PATHS } from 'src/utils/constants'

export default function useStorePersistance() {

    const bundlesFilter = useGridFilterStore(state => state.gridBundleFilters);
    const RESET = useGridFilterStore(state => state.RESET_BUNDLE_FILTER);
    const { pathname } = useLocation();

    const persistenceRoutes = [ROUTE_PATHS.BUNDLE, ROUTE_PATHS.SELLER_PROFILE, ROUTE_PATHS.PRODUCT_DETAIL];
    
    const anyValueIncludeInPath = (values: string[], pathname:string ) => {
        for (let i = 0; i < values?.length; i++) {
            if (pathname.includes(values[i])) {
              return true;
            }
          }
        return false;
    }

    useEffect(() => {
        if (!anyValueIncludeInPath(persistenceRoutes, pathname) && !bundlesFilter.isInitialState) {
            RESET()
        }
    }, [pathname])
}
